// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"sw_a bhn_b bhn_bj","StrollerbaseBanner__hint":"sw_b bhn_vh","StrollerbaseBanner__link":"sw_c"};